export default "__VITE_ASSET__BEabM9C$__"